module.exports = __webpack_public_path__ + "static/MOD6-4f539e5ba56d3caec6fd1e0a1c5813e3.jpg";